import React from 'react';
import styles from './AdminFavMenu.module.css';
import PropTypes from 'prop-types';
import P from 'components/P';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import { pageEmptyFontSize } from 'routes/adminMobile/constraints/AdminConst';
import useCustomAdminMobileMove from 'routes/adminMobile/hooks/useCustomAdminMobileMove';
import AdminMobileContentBox from './common/AdminMobileContentBox';

const AdminFavMenu = ({ favMenuList }) => {
    const {
        moveToProduct,
        moveToEvent,
        moveToNotice,
        moveToStoreSearch,
    } = useCustomAdminMobileMove();

    // favMenuList가 없거나 비어있을 때의 처리
    if (!favMenuList || favMenuList.length === 0) {
        return (
            <AdminMobileContentBox>
                <P size={pageEmptyFontSize}>
                    현재 즐겨 찾기 메뉴가 등록되어 있지 않습니다
                </P>
            </AdminMobileContentBox>
        );
    }

    const handleClickHref = href => {
        switch (href) {
            case 'product':
                moveToProduct();
                break;
            case 'event':
                moveToEvent();
                break;
            case 'notice':
                moveToNotice();
                break;
            case 'marker':
                moveToStoreSearch();
                break;
            default:
                break;
        }
    };

    return (
        <AdminMobileContentBox>
            {favMenuList.map((item, index) => (
                <div
                    key={index}
                    className={styles.favCont}
                    onClick={() => handleClickHref(item.href)}
                >
                    <VerticalFlex gap="0.5rem">
                        <FlexChild>
                            <img
                                className={styles.icon}
                                src={item.icon}
                                alt={item.menu}
                            />
                        </FlexChild>
                        <FlexChild>
                            <P size={'max(1vw, 12px)'}>{item.menu}</P>
                        </FlexChild>
                    </VerticalFlex>
                </div>
            ))}
        </AdminMobileContentBox>
    );
};

// Props의 유효성을 검사하는 코드
AdminFavMenu.propTypes = {
    favMenuList: PropTypes.arrayOf(
        PropTypes.shape({
            menu: PropTypes.string.isRequired,
            icon: PropTypes.string.isRequired,
            href: PropTypes.string.isRequired,
        }),
    ).isRequired,
};

export default AdminFavMenu;
